import { LoadedStores } from '../tables/loaded.store';
import { DispensingEventTbl } from '../tables/Events/Models/DispensingEventTbl';
import { EditUserTbl } from '../tables/Administration/Models/EditUserTbl';
import { EditEmergencyEventTbl } from '../tables/Administration/Models/EditEmergencyEventTbl';
import { UnitTbl } from '../tables/Administration/Models/UnitTbl';
import { BarcodeTbl } from '../tables/Administration/Models/ErfsManagement/Barcodes/BarcodeTbl';
import { SiteLocationDetailTbl } from '../tables/Administration/Models/EmergencyEvents/SiteLocation/SiteLocationDetailTbl';
import { ClientDetailTbl } from '../tables/Administration/Models/Clients/ClientDetailTbl';
import { AssetDetailTbl } from '../tables/Administration/Models/Assets/AssetDetailTbl';

const DispensingEventTblInstance = new DispensingEventTbl();
const EditUserTblInstance = new EditUserTbl();
const EditEmergencyEventTblInstance = new EditEmergencyEventTbl();
const UnitTblInstance = new UnitTbl();
const BarcodeTblInstance = new BarcodeTbl();
const SiteLocationDetailTblInstance = new SiteLocationDetailTbl();
const ClientDetailTblInstance = new ClientDetailTbl();
const AssetDetailTblInstance = new AssetDetailTbl();
const loadedStoresInstance = new LoadedStores();

function generateColumns<T extends Record<string, any>>(instance: T): string {
	return (Object.keys(instance) as (keyof T)[]).join(',');
}

export const DBStores = {
	DispensingEventTbl: {
		TableName: 'DispensingEventTbl',
		Columns: generateColumns(DispensingEventTblInstance)
	},
	EditUserTbl: {
		TableName: 'EditUserTbl',
		Columns: generateColumns(EditUserTblInstance)
	},
	EditEmergencyEventTbl: {
		TableName: 'EditEmergencyEventTbl',
		Columns: generateColumns(EditEmergencyEventTblInstance)
	},
	UnitTbl: {
		TableName: 'UnitTbl',
		Columns: generateColumns(UnitTblInstance)
	},
	BarcodeTbl: {
		TableName: 'BarcodeTbl',
		Columns: generateColumns(BarcodeTblInstance)
	},
	SiteLocationDetailTbl: {
		TableName: 'SiteLocationDetailTbl',
		Columns: generateColumns(SiteLocationDetailTblInstance)
	},
	ClientDetailTbl: {
		TableName: 'ClientDetailTbl',
		Columns: generateColumns(ClientDetailTblInstance)
	},
	AssetDetailTbl: {
		TableName: 'AssetDetailTbl',
		Columns: generateColumns(AssetDetailTblInstance)
	},
	LoadedStores: {
		TableName: 'LoadedStores',
		Columns: generateColumns(loadedStoresInstance)
	}
};

